var React = require('react');

function AddToFavorite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 5a1 1 0 0 1 1 1v14.191a.5.5 0 0 1-.724.447l-5.052-2.526a.5.5 0 0 0-.448 0l-5.052 2.526A.5.5 0 0 1 6 20.191V6a1 1 0 0 1 1-1h10Zm-.5 1.5h-9v12l3.606-1.792a2.01 2.01 0 0 1 1.788 0L16.5 18.5v-12Z","fill":"currentColor"}));
}

AddToFavorite.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = AddToFavorite;

AddToFavorite.default = AddToFavorite;
